export default "__VITE_ASSET__0d72ea01__"